import MessagePage from './MessagePage';

export default MessagePage;
